import { Contained } from './Contained'
import { ContainedGrey } from './ContainedGrey'
import { ContainedLight } from './ContainedLight'
import { Flat } from './Flat'
import { FlatGrey } from './FlatGrey'
import { Icon } from './Icon'
import { IconGrey } from './IconGrey'
import { Outlined } from './Outlined'
import { OutlinedGrey } from './OutlinedGrey'
import { Text } from './Text'
import { TextGrey } from './TextGrey'
import { White } from './White'
import { WhiteGrey } from './WhiteGrey'

export const BUTTONS_MENU = [
  'Buttons',
  [
    ['Contained', Contained],
    ['ContainedLight', ContainedLight],
    ['ContainedGrey', ContainedGrey],
    ['White', White],
    ['WhiteGrey', WhiteGrey],
    ['Flat', Flat],
    ['FlatGrey', FlatGrey],
    ['Outlined', Outlined],
    ['OutlinedGrey', OutlinedGrey],
    ['Text', Text],
    ['TextGrey', TextGrey],
    ['Icon', Icon],
    ['IconGrey', IconGrey],
  ],
]
